import React from 'react';
import our_inspiration from '../../assests/img/our-inspiration.jpg';
import { colors } from '@mui/material';

const OurInspiration = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Our Inspiration</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Our Inspiration
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={our_inspiration} alt="About Us" width="100%" />
                                                </p>
                                                <p>
                                                    <em>
                                                        “God has written a line of his thought on the brow of every nation”.<br />—Mazzini.
                                                    </em>
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    India is a blessed land where unfathomable wisdom of Vedas and Upanishads was composed. Education at Karamchand Memorial School is planted firmly in our Vedic and upanishadic creed. We have a firm belief that eduction should confirm to national ideals and traditions. Educational thought must orient itself to these regulative principles which have validated themselves pragmatically, by “working”, through the ages, and through tensions and crises. A national system in education that is embedded firmly in its civilisational values, helps in the evolution of each individual, society around him and nation at large, along its own lines, so that it make its particular contribution to the culture of mankind, thus vindicating the Upanishadic vision of Vasudhaiva Kutumbakam (वसुधैव कुटुम्बकम्).
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="about-us" target="_self" className="submenu">
                                                        About Us
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-inspiration"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Inspiration
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="history" target="_self" className="submenu">
                                                        History
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a className="submenu">
                                                        Messages
                                                    </a>
                                                    <div className="founder_link">
                                                        <div className="subMenubg">
                                                            <a href="founder-message" className="submenu">
                                                                Founder’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="director-message" className="submenu">
                                                                Director’s Message
                                                            </a>
                                                        </div>
                                                        <div className="subMenubg">
                                                            <a href="patron-message" className="submenu">
                                                                Patron Message
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="our-aims" target="_self" className="submenu">
                                                        Our Aims
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-ethos"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Ethos
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="our-vision.html"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Our Vision
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default OurInspiration;